// extracted by mini-css-extract-plugin
export default {"accessablityBtn":"accessablityBtn--q70cf"};